export function getMediaLabel(messageType: string): string {
  const mediaLabels: Record<string, string> = {
    photo: '[image]',
    video: '[video]',
    animation: '[gif]',
    audio: '[audio]',
    voice: '[voice]',
    document: '[document]',
    sticker: '[sticker]',
    video_note: '[video note]',
    location: '[location]',
    contact: '[contact]',
  };

  return mediaLabels[messageType] || '';
}

export function formatMessageContent(text: string, messageType: string): string {
  if (messageType === 'text') {
    return text;
  }

  const mediaLabel = getMediaLabel(messageType);

  // If there's a caption, combine media label with the text
  if (text && text.trim()) {
    return `${mediaLabel} ${text}`;
  }

  // If no caption, just return the media label
  return mediaLabel;
}
